export {default as MainC} from './components/main';
export {default as AddC} from './components/add';
export {default as AbonosC} from './components/abonos';
export {default as AbonadosActivosC} from './components/abonadosActivos';



// WEBPACK FOOTER //
// src/modules/abonados/component.js